module.exports = __webpack_public_path__ + "img/WJ.2503209c.png";